/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Digi-V API
 * This API serves objects related to the operation of Omgevingsdiensten
 * OpenAPI spec version: 1.0
 */
export type PostOthSentryTunnel401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostOthSentryTunnel400 = {
  /** A description of the error */
  message?: string;
};

export type PostOthSentryTunnel200 = { [key: string]: unknown };

export type PostOthSentryTunnelBody = { [key: string]: unknown };

export type PutOthHoofdstukReserveringId500 = {
  /** A description of the error */
  message?: string;
};

export type PutOthHoofdstukReserveringId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutOthHoofdstukReserveringId404 = {
  /** A description of the error */
  message?: string;
};

export type PutOthHoofdstukReserveringId403 = {
  /** A description of the error */
  message?: string;
};

export type PutOthHoofdstukReserveringId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutOthHoofdstukReserveringId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchOthHoofdstukReserveringId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchOthHoofdstukReserveringId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchOthHoofdstukReserveringId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchOthHoofdstukReserveringId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchOthHoofdstukReserveringId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchOthHoofdstukReserveringId400 = {
  /** A description of the error */
  message?: string;
};

export type GetOthHoofdstukReserveringId500 = {
  /** A description of the error */
  message?: string;
};

export type GetOthHoofdstukReserveringId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteOthHoofdstukReserveringId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteOthHoofdstukReserveringId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteOthHoofdstukReserveringId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteOthHoofdstukReserveringId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteOthHoofdstukReserveringId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteOthHoofdstukReserveringId400 = {
  /** A description of the error */
  message?: string;
};

export type PostOthHoofdstukReservering500 = {
  /** A description of the error */
  message?: string;
};

export type PostOthHoofdstukReservering403 = {
  /** A description of the error */
  message?: string;
};

export type PostOthHoofdstukReservering401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostOthHoofdstukReservering400 = {
  /** A description of the error */
  message?: string;
};

export type GetOthHoofdstukReservering500 = {
  /** A description of the error */
  message?: string;
};

export type GetOthHoofdstukReservering404 = {
  /** A description of the error */
  message?: string;
};

export type GetOthHoofdstukReservering400 = {
  /** A description of the error */
  message?: string;
};

export type GetOthHoofdstukReservering200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: HoofdstukReserveringSchema[];
  page?: number;
  size?: number;
};

export type GetOthHoofdstukReserveringParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type GetOthGrondslag400 = {
  /** A description of the error */
  message?: string;
};

export type GetOthGebruiker400 = {
  /** A description of the error */
  message?: string;
};

export type GetOthBesluitType400 = {
  /** A description of the error */
  message?: string;
};

export type GetOthBesluitGrondslagId500 = {
  /** A description of the error */
  message?: string;
};

export type GetOthBesluitGrondslagId404 = {
  /** A description of the error */
  message?: string;
};

export type GetOthBesluitGrondslag500 = {
  /** A description of the error */
  message?: string;
};

export type GetOthBesluitGrondslag404 = {
  /** A description of the error */
  message?: string;
};

export type GetOthBesluitGrondslag400 = {
  /** A description of the error */
  message?: string;
};

export type GetOthBesluitGrondslag200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: BesluitGrondslagSchema[];
  page?: number;
  size?: number;
};

export type GetOthBesluitGrondslagParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type GetHealth200 = {
  /** Health status */
  Status?: string;
};

export type PutFixVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixVoorschriftId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixVoorschriftId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixVoorschriftId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixVoorschriftId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixVoorschriftId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixVoorschriftId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixVoorschriftId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixVoorschriftId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixVoorschriftId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixVoorschriftId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixVoorschriftId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixVoorschriftId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixVoorschrift500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixVoorschrift403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixVoorschrift401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixVoorschrift400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixVoorschrift500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixVoorschrift404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixVoorschrift400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixVoorschrift200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: VoorschriftSchema[];
  page?: number;
  size?: number;
};

export type GetFixVoorschriftParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixSubparagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixSubparagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixSubparagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixSubparagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixSubparagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixSubparagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixSubparagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixSubparagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixSubparagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixSubparagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixSubparagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixSubparagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixSubparagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixSubparagraaf403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixSubparagraaf401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixSubparagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixSubparagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixSubparagraaf404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixSubparagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixSubparagraaf200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: SubparagraafSchema[];
  page?: number;
  size?: number;
};

export type GetFixSubparagraafParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixParagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixParagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixParagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixParagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixParagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixParagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixParagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixParagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixParagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixParagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixParagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixParagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixParagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixParagraaf403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixParagraaf401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixParagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixParagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixParagraaf404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixParagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixParagraaf200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: ParagraafSchema[];
  page?: number;
  size?: number;
};

export type GetFixParagraafParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixMetaVoorschriftOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaVoorschriftOpmerkingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaVoorschriftOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaVoorschriftOpmerkingId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaVoorschriftOpmerkingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaVoorschriftOpmerkingId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaVoorschriftOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaVoorschriftOpmerkingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaVoorschriftOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaVoorschriftOpmerkingId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaVoorschriftOpmerkingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaVoorschriftOpmerkingId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftOpmerkingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftOpmerkingId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftOpmerkingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftOpmerkingId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaVoorschriftOpmerking500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaVoorschriftOpmerking403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaVoorschriftOpmerking401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixMetaVoorschriftOpmerking400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftOpmerking500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftOpmerking404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftOpmerking400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftOpmerking200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: VoorschriftOpmerkingSchema[];
  page?: number;
  size?: number;
};

export type GetFixMetaVoorschriftOpmerkingParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixMetaVoorschriftKoppelingId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaVoorschriftKoppelingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaVoorschriftKoppelingId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaVoorschriftKoppelingId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaVoorschriftKoppelingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaVoorschriftKoppelingId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaVoorschriftKoppelingId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaVoorschriftKoppelingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaVoorschriftKoppelingId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaVoorschriftKoppelingId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaVoorschriftKoppelingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaVoorschriftKoppelingId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftKoppelingId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftKoppelingId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftKoppelingId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftKoppelingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftKoppelingId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftKoppelingId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftKoppelingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaVoorschriftKoppelingId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaVoorschriftKoppeling500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaVoorschriftKoppeling403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaVoorschriftKoppeling401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixMetaVoorschriftKoppeling400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftKoppeling500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftKoppeling404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftKoppeling400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaVoorschriftKoppeling200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: VoorschriftKoppelingSchema[];
  page?: number;
  size?: number;
};

export type GetFixMetaVoorschriftKoppelingParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixMetaOverwegingHoofdstukOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaOverwegingHoofdstukOpmerkingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaOverwegingHoofdstukOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaOverwegingHoofdstukOpmerkingId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaOverwegingHoofdstukOpmerkingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaOverwegingHoofdstukOpmerkingId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukOpmerkingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukOpmerkingId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukOpmerkingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukOpmerkingId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstukOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstukOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukOpmerkingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukOpmerkingId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukOpmerkingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukOpmerkingId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaOverwegingHoofdstukOpmerking500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaOverwegingHoofdstukOpmerking403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaOverwegingHoofdstukOpmerking401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixMetaOverwegingHoofdstukOpmerking400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstukOpmerking500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstukOpmerking404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstukOpmerking400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstukOpmerking200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: OverwegingHoofdstukOpmerkingSchema[];
  page?: number;
  size?: number;
};

export type GetFixMetaOverwegingHoofdstukOpmerkingParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixMetaOverwegingHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaOverwegingHoofdstukId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaOverwegingHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaOverwegingHoofdstukId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaOverwegingHoofdstukId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaOverwegingHoofdstukId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaOverwegingHoofdstukId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaOverwegingHoofdstukId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaOverwegingHoofdstuk500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaOverwegingHoofdstuk403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaOverwegingHoofdstuk401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixMetaOverwegingHoofdstuk400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstuk500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstuk404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstuk400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaOverwegingHoofdstuk200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: OverwegingHoofdstukSchema[];
  page?: number;
  size?: number;
};

export type GetFixMetaOverwegingHoofdstukParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixMetaEmImIssieId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaEmImIssieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaEmImIssieId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaEmImIssieId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaEmImIssieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaEmImIssieId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaEmImIssieId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaEmImIssieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaEmImIssieId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaEmImIssieId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaEmImIssieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaEmImIssieId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaEmImIssieId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaEmImIssieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaEmImIssieId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaEmImIssieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaEmImIssieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaEmImIssieId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaEmImIssieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaEmImIssieId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaEmImIssie500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaEmImIssie403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaEmImIssie401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixMetaEmImIssie400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaEmImIssie500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaEmImIssie404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaEmImIssie400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaEmImIssie200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: EmImIssieSchema[];
  page?: number;
  size?: number;
};

export type GetFixMetaEmImIssieParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixMetaDefinitieId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaDefinitieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaDefinitieId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaDefinitieId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaDefinitieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaDefinitieId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaDefinitieId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaDefinitieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaDefinitieId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaDefinitieId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaDefinitieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaDefinitieId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaDefinitieId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaDefinitieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaDefinitieId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaDefinitieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaDefinitieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaDefinitieId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaDefinitieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaDefinitieId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaDefinitie500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaDefinitie403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaDefinitie401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixMetaDefinitie400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaDefinitie500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaDefinitie404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaDefinitie400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaDefinitie200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: DefinitieSchema[];
  page?: number;
  size?: number;
};

export type GetFixMetaDefinitieParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixMetaBesluitOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaBesluitOpmerkingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaBesluitOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaBesluitOpmerkingId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixMetaBesluitOpmerkingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixMetaBesluitOpmerkingId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaBesluitOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaBesluitOpmerkingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaBesluitOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaBesluitOpmerkingId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixMetaBesluitOpmerkingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixMetaBesluitOpmerkingId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaBesluitOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaBesluitOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaBesluitOpmerkingId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaBesluitOpmerkingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaBesluitOpmerkingId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaBesluitOpmerkingId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixMetaBesluitOpmerkingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixMetaBesluitOpmerkingId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaBesluitOpmerking500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaBesluitOpmerking403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixMetaBesluitOpmerking401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixMetaBesluitOpmerking400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaBesluitOpmerking500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaBesluitOpmerking404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaBesluitOpmerking400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixMetaBesluitOpmerking200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: BesluitOpmerkingSchema[];
  page?: number;
  size?: number;
};

export type GetFixMetaBesluitOpmerkingParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLinkVspbId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkVspbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLinkVspbId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkVspbId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkVspbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLinkVspbId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkVspbId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkVspbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLinkVspbId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkVspbId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkVspbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLinkVspbId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkVspbId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkVspbId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkVspbId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkVspbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLinkVspbId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkVspbId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkVspbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLinkVspbId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkVspb500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkVspb403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkVspb401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLinkVspb400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkVspb500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkVspb404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkVspb400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkVspb200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: VSPBSchema[];
  page?: number;
  size?: number;
};

export type GetFixLinkVspbParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLinkSppbId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkSppbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLinkSppbId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkSppbId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkSppbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLinkSppbId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkSppbId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkSppbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLinkSppbId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkSppbId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkSppbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLinkSppbId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkSppbId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkSppbId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkSppbId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkSppbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLinkSppbId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkSppbId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkSppbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLinkSppbId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkSppb500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkSppb403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkSppb401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLinkSppb400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkSppb500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkSppb404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkSppb400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkSppb200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: SPPBSchema[];
  page?: number;
  size?: number;
};

export type GetFixLinkSppbParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLinkPhbId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkPhbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLinkPhbId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkPhbId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkPhbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLinkPhbId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkPhbId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkPhbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLinkPhbId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkPhbId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkPhbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLinkPhbId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkPhbId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkPhbId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkPhbId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkPhbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLinkPhbId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkPhbId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkPhbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLinkPhbId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkPhb500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkPhb403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkPhb401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLinkPhb400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkPhb500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkPhb404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkPhb400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkPhb200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: PHBSchema[];
  page?: number;
  size?: number;
};

export type GetFixLinkPhbParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLinkHbId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkHbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLinkHbId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkHbId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLinkHbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLinkHbId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkHbId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkHbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLinkHbId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkHbId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLinkHbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLinkHbId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkHbId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkHbId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkHbId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkHbId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLinkHbId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkHbId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLinkHbId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLinkHbId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkHb500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkHb403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLinkHb401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLinkHb400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkHb500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkHb404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkHb400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLinkHb200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: HBSchema[];
  page?: number;
  size?: number;
};

export type GetFixLinkHbParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLineageVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageVoorschriftId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageVoorschriftId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageVoorschriftId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageVoorschriftId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageVoorschriftId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageVoorschriftId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageVoorschriftId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageVoorschriftId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageVoorschriftId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageVoorschriftId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageVoorschriftId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageVoorschriftId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageVoorschrift500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageVoorschrift403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageVoorschrift401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLineageVoorschrift400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageVoorschrift500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageVoorschrift404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageVoorschrift400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageVoorschrift200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: VoorschriftLineageSchema[];
  page?: number;
  size?: number;
};

export type GetFixLineageVoorschriftParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLineageSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageSubparagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageSubparagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageSubparagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageSubparagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageSubparagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageSubparagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageSubparagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageSubparagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageSubparagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageSubparagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageSubparagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageSubparagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageSubparagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageSubparagraaf403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageSubparagraaf401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLineageSubparagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageSubparagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageSubparagraaf404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageSubparagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageSubparagraaf200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: SubparagraafLineageSchema[];
  page?: number;
  size?: number;
};

export type GetFixLineageSubparagraafParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLineageParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageParagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageParagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageParagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageParagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageParagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageParagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageParagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageParagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageParagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageParagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageParagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageParagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageParagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageParagraaf403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageParagraaf401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLineageParagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageParagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageParagraaf404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageParagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageParagraaf200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: ParagraafLineageSchema[];
  page?: number;
  size?: number;
};

export type GetFixLineageParagraafParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLineageHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageHoofdstukId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageHoofdstukId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageHoofdstukId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageHoofdstukId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageHoofdstukId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageHoofdstukId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageHoofdstukId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageHoofdstukId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageHoofdstukId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageHoofdstukId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageHoofdstukId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageHoofdstukId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageHoofdstuk500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageHoofdstuk403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageHoofdstuk401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLineageHoofdstuk400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageHoofdstuk500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageHoofdstuk404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageHoofdstuk400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageHoofdstuk200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: HoofdstukLineageSchema[];
  page?: number;
  size?: number;
};

export type GetFixLineageHoofdstukParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLineageBevoegdGezagId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageBevoegdGezagId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageBevoegdGezagId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageBevoegdGezagId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageBevoegdGezagId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageBevoegdGezagId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBevoegdGezagId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBevoegdGezagId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageBevoegdGezagId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBevoegdGezagId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBevoegdGezagId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageBevoegdGezagId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBevoegdGezagId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBevoegdGezagId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBevoegdGezagId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBevoegdGezagId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageBevoegdGezagId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBevoegdGezagId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBevoegdGezagId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageBevoegdGezagId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageBevoegdGezag500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageBevoegdGezag403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageBevoegdGezag401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLineageBevoegdGezag400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBevoegdGezag500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBevoegdGezag404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBevoegdGezag400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBevoegdGezag200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: BevoegdGezagLineageSchema[];
  page?: number;
  size?: number;
};

export type GetFixLineageBevoegdGezagParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLineageBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageBesluit500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageBesluit403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageBesluit401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLineageBesluit400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBesluit500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBesluit404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBesluit400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBesluit200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: BesluitLineageSchema[];
  page?: number;
  size?: number;
};

export type GetFixLineageBesluitParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixLineageBedrijfId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageBedrijfId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageBedrijfId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageBedrijfId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixLineageBedrijfId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixLineageBedrijfId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBedrijfId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBedrijfId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageBedrijfId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBedrijfId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixLineageBedrijfId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixLineageBedrijfId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBedrijfId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBedrijfId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBedrijfId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBedrijfId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageBedrijfId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBedrijfId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixLineageBedrijfId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixLineageBedrijfId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageBedrijf500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageBedrijf403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixLineageBedrijf401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixLineageBedrijf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBedrijf500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBedrijf404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBedrijf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixLineageBedrijf200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: BedrijfLineageSchema[];
  page?: number;
  size?: number;
};

export type GetFixLineageBedrijfParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixHoofdstukId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixHoofdstukId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixHoofdstukId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixHoofdstukId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixHoofdstukId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixHoofdstukId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixHoofdstukId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixHoofdstukId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixHoofdstukId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixHoofdstukId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixHoofdstukId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixHoofdstukId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixHoofdstukId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixHoofdstukId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixHoofdstuk500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixHoofdstuk403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixHoofdstuk401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixHoofdstuk400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixHoofdstuk500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixHoofdstuk404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixHoofdstuk400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixHoofdstuk200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: HoofdstukSchema[];
  page?: number;
  size?: number;
};

export type GetFixHoofdstukParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixBevoegdGezagId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixBevoegdGezagId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixBevoegdGezagId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixBevoegdGezagId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixBevoegdGezagId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixBevoegdGezagId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBevoegdGezagId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBevoegdGezagId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixBevoegdGezagId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBevoegdGezagId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBevoegdGezagId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixBevoegdGezagId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBevoegdGezagId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBevoegdGezagId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBevoegdGezagId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBevoegdGezagId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixBevoegdGezagId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBevoegdGezagId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBevoegdGezagId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixBevoegdGezagId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixBevoegdGezag500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixBevoegdGezag403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixBevoegdGezag401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixBevoegdGezag400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBevoegdGezag500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBevoegdGezag404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBevoegdGezag400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBevoegdGezag200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: BevoegdGezagSchema[];
  page?: number;
  size?: number;
};

export type GetFixBevoegdGezagParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixBesluit500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixBesluit403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixBesluit401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixBesluit400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBesluit500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBesluit404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBesluit400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBesluit200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: BesluitSchema[];
  page?: number;
  size?: number;
};

export type GetFixBesluitParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutFixBedrijfId500 = {
  /** A description of the error */
  message?: string;
};

export type PutFixBedrijfId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixBedrijfId404 = {
  /** A description of the error */
  message?: string;
};

export type PutFixBedrijfId403 = {
  /** A description of the error */
  message?: string;
};

export type PutFixBedrijfId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutFixBedrijfId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBedrijfId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBedrijfId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixBedrijfId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBedrijfId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchFixBedrijfId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchFixBedrijfId400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBedrijfId500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBedrijfId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBedrijfId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBedrijfId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixBedrijfId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBedrijfId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteFixBedrijfId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteFixBedrijfId400 = {
  /** A description of the error */
  message?: string;
};

export type PostFixBedrijf500 = {
  /** A description of the error */
  message?: string;
};

export type PostFixBedrijf403 = {
  /** A description of the error */
  message?: string;
};

export type PostFixBedrijf401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostFixBedrijf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBedrijf500 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBedrijf404 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBedrijf400 = {
  /** A description of the error */
  message?: string;
};

export type GetFixBedrijf200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: BedrijfSchema[];
  page?: number;
  size?: number;
};

export type GetFixBedrijfParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynStdVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdVoorschriftId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynStdVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdVoorschriftId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdVoorschriftId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynStdVoorschriftId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdVoorschriftId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynStdVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdVoorschriftId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdVoorschriftId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynStdVoorschriftId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdVoorschriftId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdVoorschriftId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynStdVoorschriftId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdVoorschriftId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdVoorschriftId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynStdVoorschriftId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdVoorschrift500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdVoorschrift403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdVoorschrift401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynStdVoorschrift400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdVoorschrift500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdVoorschrift404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdVoorschrift400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdVoorschrift200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: STDVoorschriftSchema[];
  page?: number;
  size?: number;
};

export type GetDynStdVoorschriftParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynStdSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdSubparagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynStdSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdSubparagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdSubparagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynStdSubparagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdSubparagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynStdSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdSubparagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdSubparagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynStdSubparagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdSubparagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdSubparagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynStdSubparagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdSubparagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdSubparagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynStdSubparagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdSubparagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdSubparagraaf403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdSubparagraaf401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynStdSubparagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdSubparagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdSubparagraaf404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdSubparagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdSubparagraaf200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: STDSubparagraafSchema[];
  page?: number;
  size?: number;
};

export type GetDynStdSubparagraafParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynStdParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdParagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynStdParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdParagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdParagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynStdParagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdParagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynStdParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdParagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdParagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynStdParagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdParagraafId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdParagraafId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynStdParagraafId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdParagraafId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdParagraafId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynStdParagraafId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdParagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdParagraaf403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdParagraaf401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynStdParagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdParagraaf500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdParagraaf404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdParagraaf400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdParagraaf200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: STDParagraafSchema[];
  page?: number;
  size?: number;
};

export type GetDynStdParagraafParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynStdMapId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdMapId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynStdMapId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdMapId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynStdMapId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynStdMapId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdMapId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdMapId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynStdMapId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdMapId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynStdMapId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynStdMapId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdMapId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdMapId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdMapId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdMapId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynStdMapId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdMapId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynStdMapId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynStdMapId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdMap500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdMap403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynStdMap401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynStdMap400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdMap500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdMap404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdMap400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynStdMap200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: STDMapSchema[];
  page?: number;
  size?: number;
};

export type GetDynStdMapParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynMetaVoorschriftLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaVoorschriftLabelId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaVoorschriftLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaVoorschriftLabelId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaVoorschriftLabelId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaVoorschriftLabelId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftLabelId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaVoorschriftLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftLabelId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftLabelId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaVoorschriftLabelId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftLabelId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftLabelId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftLabelId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftLabelId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaVoorschriftLabel500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaVoorschriftLabel403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaVoorschriftLabel401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynMetaVoorschriftLabel400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftLabel500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftLabel404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftLabel400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftLabel200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: VoorschriftLabelSchema[];
  page?: number;
  size?: number;
};

export type GetDynMetaVoorschriftLabelParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynMetaVoorschriftHistorischBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaVoorschriftHistorischBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaVoorschriftHistorischBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaVoorschriftHistorischBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaVoorschriftHistorischBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaVoorschriftHistorischBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftHistorischBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftHistorischBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaVoorschriftHistorischBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftHistorischBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftHistorischBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaVoorschriftHistorischBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftHistorischBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftHistorischBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftHistorischBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftHistorischBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftHistorischBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftHistorischBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftHistorischBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftHistorischBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaVoorschriftHistorischBesluit500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaVoorschriftHistorischBesluit403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaVoorschriftHistorischBesluit401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynMetaVoorschriftHistorischBesluit400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftHistorischBesluit500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftHistorischBesluit404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftHistorischBesluit400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftHistorischBesluit200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: VoorschriftHistorischBesluitSchema[];
  page?: number;
  size?: number;
};

export type GetDynMetaVoorschriftHistorischBesluitParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynMetaVoorschriftActiviteitInstallatieId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaVoorschriftActiviteitInstallatieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaVoorschriftActiviteitInstallatieId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaVoorschriftActiviteitInstallatieId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaVoorschriftActiviteitInstallatieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaVoorschriftActiviteitInstallatieId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftActiviteitInstallatieId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftActiviteitInstallatieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaVoorschriftActiviteitInstallatieId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftActiviteitInstallatieId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaVoorschriftActiviteitInstallatieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaVoorschriftActiviteitInstallatieId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftActiviteitInstallatieId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftActiviteitInstallatieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftActiviteitInstallatieId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftActiviteitInstallatieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftActiviteitInstallatieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftActiviteitInstallatieId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftActiviteitInstallatieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaVoorschriftActiviteitInstallatieId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaVoorschriftActiviteitInstallatie500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaVoorschriftActiviteitInstallatie403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaVoorschriftActiviteitInstallatie401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynMetaVoorschriftActiviteitInstallatie400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftActiviteitInstallatie500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftActiviteitInstallatie404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftActiviteitInstallatie400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaVoorschriftActiviteitInstallatie200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: VoorschriftActiviteitInstallatieSchema[];
  page?: number;
  size?: number;
};

export type GetDynMetaVoorschriftActiviteitInstallatieParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynMetaStdVoorschriftLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdVoorschriftLabelId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaStdVoorschriftLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdVoorschriftLabelId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdVoorschriftLabelId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaStdVoorschriftLabelId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftLabelId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftLabelId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftLabelId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftLabelId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftLabelId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftLabelId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftLabelId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftLabelId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdVoorschriftLabel500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdVoorschriftLabel403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdVoorschriftLabel401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynMetaStdVoorschriftLabel400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftLabel500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftLabel404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftLabel400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftLabel200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: STDVoorschriftLabelSchema[];
  page?: number;
  size?: number;
};

export type GetDynMetaStdVoorschriftLabelParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynMetaStdVoorschriftKoppelingId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdVoorschriftKoppelingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaStdVoorschriftKoppelingId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdVoorschriftKoppelingId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdVoorschriftKoppelingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaStdVoorschriftKoppelingId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftKoppelingId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftKoppelingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftKoppelingId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftKoppelingId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftKoppelingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaStdVoorschriftKoppelingId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftKoppelingId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftKoppelingId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftKoppelingId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftKoppelingId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftKoppelingId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftKoppelingId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftKoppelingId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaStdVoorschriftKoppelingId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdVoorschriftKoppeling500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdVoorschriftKoppeling403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdVoorschriftKoppeling401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynMetaStdVoorschriftKoppeling400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftKoppeling500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftKoppeling404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftKoppeling400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdVoorschriftKoppeling200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: STDVoorschriftKoppelingSchema[];
  page?: number;
  size?: number;
};

export type GetDynMetaStdVoorschriftKoppelingParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynMetaStdEmImIssieId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdEmImIssieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaStdEmImIssieId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdEmImIssieId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdEmImIssieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaStdEmImIssieId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdEmImIssieId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdEmImIssieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaStdEmImIssieId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdEmImIssieId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdEmImIssieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaStdEmImIssieId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdEmImIssieId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdEmImIssieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdEmImIssieId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdEmImIssieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaStdEmImIssieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdEmImIssieId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdEmImIssieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaStdEmImIssieId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdEmImIssie500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdEmImIssie403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdEmImIssie401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynMetaStdEmImIssie400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdEmImIssie500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdEmImIssie404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdEmImIssie400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdEmImIssie200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: STDEmImIssieSchema[];
  page?: number;
  size?: number;
};

export type GetDynMetaStdEmImIssieParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynMetaStdDefinitieId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdDefinitieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaStdDefinitieId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdDefinitieId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaStdDefinitieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaStdDefinitieId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdDefinitieId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdDefinitieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaStdDefinitieId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdDefinitieId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaStdDefinitieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaStdDefinitieId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdDefinitieId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdDefinitieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdDefinitieId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdDefinitieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaStdDefinitieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdDefinitieId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaStdDefinitieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaStdDefinitieId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdDefinitie500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdDefinitie403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaStdDefinitie401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynMetaStdDefinitie400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdDefinitie500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdDefinitie404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdDefinitie400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaStdDefinitie200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: STDDefinitieSchema[];
  page?: number;
  size?: number;
};

export type GetDynMetaStdDefinitieParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynMetaBedrijfInstallatieId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaBedrijfInstallatieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaBedrijfInstallatieId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaBedrijfInstallatieId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaBedrijfInstallatieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaBedrijfInstallatieId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaBedrijfInstallatieId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaBedrijfInstallatieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaBedrijfInstallatieId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaBedrijfInstallatieId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaBedrijfInstallatieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaBedrijfInstallatieId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfInstallatieId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfInstallatieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaBedrijfInstallatieId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaBedrijfInstallatieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaBedrijfInstallatieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaBedrijfInstallatieId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaBedrijfInstallatieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaBedrijfInstallatieId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaBedrijfInstallatie500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaBedrijfInstallatie403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaBedrijfInstallatie401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynMetaBedrijfInstallatie400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfInstallatie500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfInstallatie404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfInstallatie400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfInstallatie200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: BedrijfInstallatieSchema[];
  page?: number;
  size?: number;
};

export type GetDynMetaBedrijfInstallatieParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynMetaBedrijfActiviteitId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaBedrijfActiviteitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaBedrijfActiviteitId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaBedrijfActiviteitId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynMetaBedrijfActiviteitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynMetaBedrijfActiviteitId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaBedrijfActiviteitId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaBedrijfActiviteitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaBedrijfActiviteitId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaBedrijfActiviteitId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynMetaBedrijfActiviteitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynMetaBedrijfActiviteitId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfActiviteitId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfActiviteitId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaBedrijfActiviteitId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaBedrijfActiviteitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaBedrijfActiviteitId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaBedrijfActiviteitId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynMetaBedrijfActiviteitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynMetaBedrijfActiviteitId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaBedrijfActiviteit500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaBedrijfActiviteit403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynMetaBedrijfActiviteit401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynMetaBedrijfActiviteit400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfActiviteit500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfActiviteit404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfActiviteit400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynMetaBedrijfActiviteit200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: BedrijfActiviteitSchema[];
  page?: number;
  size?: number;
};

export type GetDynMetaBedrijfActiviteitParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynLabelMapId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynLabelMapId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynLabelMapId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynLabelMapId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynLabelMapId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynLabelMapId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynLabelMapId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynLabelMapId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynLabelMapId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynLabelMapId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynLabelMapId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynLabelMapId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabelMapId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabelMapId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynLabelMapId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynLabelMapId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynLabelMapId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynLabelMapId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynLabelMapId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynLabelMapId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynLabelMap500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynLabelMap403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynLabelMap401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynLabelMap400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabelMap500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabelMap404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabelMap400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabelMap200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: LabelMapSchema[];
  page?: number;
  size?: number;
};

export type GetDynLabelMapParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynLabelId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynLabelId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynLabelId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynLabelId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynLabelId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynLabelId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynLabelId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynLabelId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynLabelId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynLabelId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynLabelId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynLabelId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynLabelId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynLabelId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynLabel500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynLabel403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynLabel401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynLabel400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabel500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabel404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabel400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynLabel200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: LabelSchema[];
  page?: number;
  size?: number;
};

export type GetDynLabelParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynInstallatieTypeId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynInstallatieTypeId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynInstallatieTypeId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynInstallatieTypeId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynInstallatieTypeId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynInstallatieTypeId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynInstallatieTypeId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynInstallatieTypeId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynInstallatieTypeId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynInstallatieTypeId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynInstallatieTypeId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynInstallatieTypeId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynInstallatieTypeId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynInstallatieTypeId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynInstallatieTypeId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynInstallatieTypeId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynInstallatieTypeId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynInstallatieTypeId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynInstallatieTypeId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynInstallatieTypeId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynInstallatieType500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynInstallatieType403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynInstallatieType401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynInstallatieType400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynInstallatieType500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynInstallatieType404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynInstallatieType400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynInstallatieType200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: InstallatieTypeSchema[];
  page?: number;
  size?: number;
};

export type GetDynInstallatieTypeParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynHistorischBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynHistorischBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynHistorischBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynHistorischBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynHistorischBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynHistorischBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynHistorischBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynHistorischBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynHistorischBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynHistorischBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynHistorischBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynHistorischBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynHistorischBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynHistorischBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynHistorischBesluitId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynHistorischBesluitId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynHistorischBesluitId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynHistorischBesluitId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynHistorischBesluitId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynHistorischBesluitId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynHistorischBesluit500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynHistorischBesluit403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynHistorischBesluit401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynHistorischBesluit400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynHistorischBesluit500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynHistorischBesluit404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynHistorischBesluit400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynHistorischBesluit200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: HistorischBesluitSchema[];
  page?: number;
  size?: number;
};

export type GetDynHistorischBesluitParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type PutDynActiviteitCategorieId500 = {
  /** A description of the error */
  message?: string;
};

export type PutDynActiviteitCategorieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynActiviteitCategorieId404 = {
  /** A description of the error */
  message?: string;
};

export type PutDynActiviteitCategorieId403 = {
  /** A description of the error */
  message?: string;
};

export type PutDynActiviteitCategorieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PutDynActiviteitCategorieId400 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynActiviteitCategorieId500 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynActiviteitCategorieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynActiviteitCategorieId404 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynActiviteitCategorieId403 = {
  /** A description of the error */
  message?: string;
};

export type PatchDynActiviteitCategorieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PatchDynActiviteitCategorieId400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynActiviteitCategorieId500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynActiviteitCategorieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynActiviteitCategorieId500 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynActiviteitCategorieId409 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynActiviteitCategorieId404 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynActiviteitCategorieId403 = {
  /** A description of the error */
  message?: string;
};

export type DeleteDynActiviteitCategorieId401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type DeleteDynActiviteitCategorieId400 = {
  /** A description of the error */
  message?: string;
};

export type PostDynActiviteitCategorie500 = {
  /** A description of the error */
  message?: string;
};

export type PostDynActiviteitCategorie403 = {
  /** A description of the error */
  message?: string;
};

export type PostDynActiviteitCategorie401 = {
  /** A description of the error */
  error?: string;
  /** Rationale behind the error */
  message?: string;
};

export type PostDynActiviteitCategorie400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynActiviteitCategorie500 = {
  /** A description of the error */
  message?: string;
};

export type GetDynActiviteitCategorie404 = {
  /** A description of the error */
  message?: string;
};

export type GetDynActiviteitCategorie400 = {
  /** A description of the error */
  message?: string;
};

export type GetDynActiviteitCategorie200 = {
  num_objects?: number;
  num_pages?: number;
  objects?: ActiviteitCategorieSchema[];
  page?: number;
  size?: number;
};

export type GetDynActiviteitCategorieParams = {
  /**
   * Page number
   */
  page: number;
  /**
   * Page size
   */
  size: number;
  /**
   * Filter specification
   */
  filter?: FilterSchema[];
  /**
   * Sort specification
   */
  sort?: SortSchema[];
};

export type GetAuthTokeninfo200 = {
  /** Expiry time for the JWT token */
  expires?: string;
  /** User identifier */
  identifier?: string;
};

export type PostAuthLogin401 = {
  /** A description of the error */
  message?: string;
};

export type PostAuthLogin400 = {
  /** A description of the error */
  message?: string;
};

/**
 * User identifier
 */
export type PostAuthLogin200Identifier = {
  Email?: string;
  Gebruikersnaam?: string;
  ID?: string;
  Rol?: string;
};

export type PostAuthLogin200 = {
  /** JWT token */
  access_token?: string;
  /** The deployment type for the server logged in to */
  'deployment type'?: string;
  /** Expiry time for the JWT token */
  expires?: string;
  /** User identifier */
  identifier?: PostAuthLogin200Identifier;
};

export type PostAuthLoginBody = {
  /** User identifier */
  identifier?: string;
  /** User password */
  password?: string;
};

export type Get200 = {
  /** Health status */
  Status?: string;
};

export type VoorschriftSchemaOptionalObjectStatus =
  (typeof VoorschriftSchemaOptionalObjectStatus)[keyof typeof VoorschriftSchemaOptionalObjectStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VoorschriftSchemaOptionalObjectStatus = {
  Standaard: 'Standaard',
  Hersteld: 'Hersteld',
  IngetrokkenGepubliceerd: 'IngetrokkenGepubliceerd',
} as const;

export interface VoorschriftSchemaOptional {
  /** @nullable */
  Begin_Geldigheid?: string | null;
  /** @nullable */
  Beroep_Ingediend?: number | null;
  /** @nullable */
  Eind_Geldigheid?: string | null;
  ID?: string;
  Index?: number;
  Lineage?: string;
  /** @maxLength 3 */
  Nummer?: string;
  ObjectStatus?: VoorschriftSchemaOptionalObjectStatus;
  Ontwerp?: number;
  Stop_Lineage?: number;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Voorlopige_Voorziening?: number | null;
  Voorschrift?: string;
  /** @nullable */
  Vorig?: string | null;
}

export type VoorschriftSchemaObjectStatus =
  (typeof VoorschriftSchemaObjectStatus)[keyof typeof VoorschriftSchemaObjectStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VoorschriftSchemaObjectStatus = {
  Standaard: 'Standaard',
  Hersteld: 'Hersteld',
  IngetrokkenGepubliceerd: 'IngetrokkenGepubliceerd',
} as const;

export interface VoorschriftSchema {
  /** @nullable */
  Begin_Geldigheid?: string | null;
  /** @nullable */
  Beroep_Ingediend?: number | null;
  /** @nullable */
  Eind_Geldigheid?: string | null;
  ID: string;
  Index: number;
  Lineage: string;
  /** @maxLength 3 */
  Nummer: string;
  ObjectStatus: VoorschriftSchemaObjectStatus;
  Ontwerp: number;
  Stop_Lineage: number;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Voorlopige_Voorziening?: number | null;
  Voorschrift: string;
  /** @nullable */
  Vorig?: string | null;
}

export interface VoorschriftOpmerkingSchemaOptional {
  Check?: number;
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Index?: number;
  Modified_By?: string;
  Modified_Date?: string;
  Opmerking?: string;
  Voorschrift?: string;
}

export interface VoorschriftOpmerkingSchema {
  Check: number;
  Created_By: string;
  Created_Date: string;
  ID: string;
  Index: number;
  Modified_By: string;
  Modified_Date: string;
  Opmerking: string;
  Voorschrift: string;
}

export interface VoorschriftLineageSchemaOptional {
  Besluit_lineage?: string;
  ID?: string;
}

export interface VoorschriftLineageSchema {
  Besluit_lineage: string;
  ID: string;
}

export interface VoorschriftLabelSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Label?: string;
  Modified_By?: string;
  Modified_Date?: string;
  Voorschrift_lineage?: string;
}

export interface VoorschriftLabelSchema {
  Created_By: string;
  Created_Date: string;
  ID: string;
  Label: string;
  Modified_By: string;
  Modified_Date: string;
  Voorschrift_lineage: string;
}

export interface VoorschriftKoppelingSchemaOptional {
  ID?: string;
  Voorschrift_1?: string;
  Voorschrift_2?: string;
}

export interface VoorschriftKoppelingSchema {
  ID: string;
  Voorschrift_1: string;
  Voorschrift_2: string;
}

export interface VoorschriftHistorischBesluitSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  Historisch_besluit?: string;
  ID?: string;
  Modified_By?: string;
  Modified_Date?: string;
  /** @nullable */
  Origineel_voorschriftnummer?: string | null;
  Voorschrift_lineage?: string;
}

export interface VoorschriftHistorischBesluitSchema {
  Created_By: string;
  Created_Date: string;
  Historisch_besluit: string;
  ID: string;
  Modified_By: string;
  Modified_Date: string;
  /** @nullable */
  Origineel_voorschriftnummer?: string | null;
  Voorschrift_lineage: string;
}

export interface VoorschriftActiviteitInstallatieSchemaOptional {
  Bedrijf_activiteit?: string;
  Bedrijf_installatie?: string;
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Modified_By?: string;
  Modified_Date?: string;
  Voorschrift_lineage?: string;
}

export interface VoorschriftActiviteitInstallatieSchema {
  Bedrijf_activiteit: string;
  Bedrijf_installatie: string;
  Created_By: string;
  Created_Date: string;
  ID: string;
  Modified_By: string;
  Modified_Date: string;
  Voorschrift_lineage: string;
}

export type VSPBSchemaOptionalType =
  (typeof VSPBSchemaOptionalType)[keyof typeof VSPBSchemaOptionalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VSPBSchemaOptionalType = {
  Eigen: 'Eigen',
  Publicatie: 'Publicatie',
  MBIO: 'MBIO',
} as const;

export interface VSPBSchemaOptional {
  Besluit?: string;
  ID?: string;
  /** @maxLength 1000 */
  Rang?: string;
  Subparagraaf?: string;
  Type?: VSPBSchemaOptionalType;
  Voorschrift?: string;
}

export type VSPBSchemaType =
  (typeof VSPBSchemaType)[keyof typeof VSPBSchemaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VSPBSchemaType = {
  Eigen: 'Eigen',
  Publicatie: 'Publicatie',
  MBIO: 'MBIO',
} as const;

export interface VSPBSchema {
  Besluit: string;
  ID: string;
  /** @maxLength 1000 */
  Rang: string;
  Subparagraaf: string;
  Type: VSPBSchemaType;
  Voorschrift: string;
}

export type SubparagraafSchemaOptionalObjectStatus =
  (typeof SubparagraafSchemaOptionalObjectStatus)[keyof typeof SubparagraafSchemaOptionalObjectStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubparagraafSchemaOptionalObjectStatus = {
  Standaard: 'Standaard',
  Hersteld: 'Hersteld',
  IngetrokkenGepubliceerd: 'IngetrokkenGepubliceerd',
} as const;

export interface SubparagraafSchemaOptional {
  ID?: string;
  Index?: number;
  Lineage?: string;
  ObjectStatus?: SubparagraafSchemaOptionalObjectStatus;
  Ontwerp?: number;
  Stop_Lineage?: number;
  Titel?: string;
  Transparent?: number;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
}

export type SubparagraafSchemaObjectStatus =
  (typeof SubparagraafSchemaObjectStatus)[keyof typeof SubparagraafSchemaObjectStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubparagraafSchemaObjectStatus = {
  Standaard: 'Standaard',
  Hersteld: 'Hersteld',
  IngetrokkenGepubliceerd: 'IngetrokkenGepubliceerd',
} as const;

export interface SubparagraafSchema {
  ID: string;
  Index: number;
  Lineage: string;
  ObjectStatus: SubparagraafSchemaObjectStatus;
  Ontwerp: number;
  Stop_Lineage: number;
  Titel: string;
  Transparent: number;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
}

export interface SubparagraafLineageSchemaOptional {
  Besluit_lineage?: string;
  ID?: string;
}

export interface SubparagraafLineageSchema {
  Besluit_lineage: string;
  ID: string;
}

export type SortSchemaDirection =
  (typeof SortSchemaDirection)[keyof typeof SortSchemaDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortSchemaDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export interface SortSchema {
  direction: SortSchemaDirection;
  field: string;
  model?: string;
}

export interface STDVoorschriftSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Modified_By?: string;
  Modified_Date?: string;
  Nummer?: string;
  /** @maxLength 1000 */
  Rang?: string;
  Subparagraaf?: string;
  /** @nullable */
  Toelichting?: string | null;
  Voorschrift?: string;
}

export interface STDVoorschriftSchema {
  Created_By: string;
  Created_Date: string;
  ID: string;
  Modified_By: string;
  Modified_Date: string;
  Nummer: string;
  /** @maxLength 1000 */
  Rang: string;
  Subparagraaf: string;
  /** @nullable */
  Toelichting?: string | null;
  Voorschrift: string;
}

export interface STDVoorschriftLabelSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Label?: string;
  Modified_By?: string;
  Modified_Date?: string;
  STD_Voorschrift?: string;
}

export interface STDVoorschriftLabelSchema {
  Created_By: string;
  Created_Date: string;
  ID: string;
  Label: string;
  Modified_By: string;
  Modified_Date: string;
  STD_Voorschrift: string;
}

export interface STDVoorschriftKoppelingSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Modified_By?: string;
  Modified_Date?: string;
  STD_Voorschrift_1?: string;
  STD_Voorschrift_2?: string;
}

export interface STDVoorschriftKoppelingSchema {
  Created_By: string;
  Created_Date: string;
  ID: string;
  Modified_By: string;
  Modified_Date: string;
  STD_Voorschrift_1: string;
  STD_Voorschrift_2: string;
}

export interface STDSubparagraafSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Modified_By?: string;
  Modified_Date?: string;
  Paragraaf?: string;
  /** @maxLength 1000 */
  Rang?: string;
  Titel?: string;
  /** @nullable */
  Toelichting?: string | null;
  Transparent?: number;
}

export interface STDSubparagraafSchema {
  Created_By: string;
  Created_Date: string;
  ID: string;
  Modified_By: string;
  Modified_Date: string;
  Paragraaf: string;
  /** @maxLength 1000 */
  Rang: string;
  Titel: string;
  /** @nullable */
  Toelichting?: string | null;
  Transparent: number;
}

export interface STDParagraafSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Map?: string;
  Modified_By?: string;
  Modified_Date?: string;
  Nummer?: string;
  /** @maxLength 1000 */
  Rang?: string;
  Titel?: string;
  /** @nullable */
  Toelichting?: string | null;
}

export interface STDParagraafSchema {
  Created_By: string;
  Created_Date: string;
  ID: string;
  Map: string;
  Modified_By: string;
  Modified_Date: string;
  Nummer: string;
  /** @maxLength 1000 */
  Rang: string;
  Titel: string;
  /** @nullable */
  Toelichting?: string | null;
}

export type STDMapSchemaOptionalStatus =
  (typeof STDMapSchemaOptionalStatus)[keyof typeof STDMapSchemaOptionalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const STDMapSchemaOptionalStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface STDMapSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  Grondslag?: string;
  ID?: string;
  /** @nullable */
  InhoudelijkeOverweging?: string | null;
  Landelijk?: number;
  /** @nullable */
  Map?: string | null;
  Modified_By?: string;
  Modified_Date?: string;
  /** @maxLength 100 */
  Naam?: string;
  Status?: STDMapSchemaOptionalStatus;
  Tenant?: string;
  /** @nullable */
  Toelichting?: string | null;
}

export type STDMapSchemaStatus =
  (typeof STDMapSchemaStatus)[keyof typeof STDMapSchemaStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const STDMapSchemaStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface STDMapSchema {
  Created_By: string;
  Created_Date: string;
  Grondslag: string;
  ID: string;
  /** @nullable */
  InhoudelijkeOverweging?: string | null;
  Landelijk: number;
  /** @nullable */
  Map?: string | null;
  Modified_By: string;
  Modified_Date: string;
  /** @maxLength 100 */
  Naam: string;
  Status: STDMapSchemaStatus;
  Tenant: string;
  /** @nullable */
  Toelichting?: string | null;
}

export interface STDEmImIssieSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  /** @nullable */
  Gegeven?: string | null;
  ID?: string;
  Modified_By?: string;
  Modified_Date?: string;
  STD_Voorschrift?: string;
}

export interface STDEmImIssieSchema {
  Created_By: string;
  Created_Date: string;
  /** @nullable */
  Gegeven?: string | null;
  ID: string;
  Modified_By: string;
  Modified_Date: string;
  STD_Voorschrift: string;
}

export interface STDDefinitieSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  /** @nullable */
  Definitie?: string | null;
  ID?: string;
  Modified_By?: string;
  Modified_Date?: string;
  STD_Voorschrift?: string;
}

export interface STDDefinitieSchema {
  Created_By: string;
  Created_Date: string;
  /** @nullable */
  Definitie?: string | null;
  ID: string;
  Modified_By: string;
  Modified_Date: string;
  STD_Voorschrift: string;
}

export type SPPBSchemaOptionalType =
  (typeof SPPBSchemaOptionalType)[keyof typeof SPPBSchemaOptionalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SPPBSchemaOptionalType = {
  Eigen: 'Eigen',
  Publicatie: 'Publicatie',
  MBIO: 'MBIO',
} as const;

export interface SPPBSchemaOptional {
  Besluit?: string;
  ID?: string;
  Paragraaf?: string;
  /** @maxLength 1000 */
  Rang?: string;
  Subparagraaf?: string;
  Type?: SPPBSchemaOptionalType;
}

export type SPPBSchemaType =
  (typeof SPPBSchemaType)[keyof typeof SPPBSchemaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SPPBSchemaType = {
  Eigen: 'Eigen',
  Publicatie: 'Publicatie',
  MBIO: 'MBIO',
} as const;

export interface SPPBSchema {
  Besluit: string;
  ID: string;
  Paragraaf: string;
  /** @maxLength 1000 */
  Rang: string;
  Subparagraaf: string;
  Type: SPPBSchemaType;
}

export type ParagraafSchemaOptionalObjectStatus =
  (typeof ParagraafSchemaOptionalObjectStatus)[keyof typeof ParagraafSchemaOptionalObjectStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParagraafSchemaOptionalObjectStatus = {
  Standaard: 'Standaard',
  Hersteld: 'Hersteld',
  IngetrokkenGepubliceerd: 'IngetrokkenGepubliceerd',
} as const;

export interface ParagraafSchemaOptional {
  ID?: string;
  Index?: number;
  Lineage?: string;
  Nummer?: number;
  ObjectStatus?: ParagraafSchemaOptionalObjectStatus;
  Ontwerp?: number;
  Stop_Lineage?: number;
  Titel?: string;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
}

export type ParagraafSchemaObjectStatus =
  (typeof ParagraafSchemaObjectStatus)[keyof typeof ParagraafSchemaObjectStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParagraafSchemaObjectStatus = {
  Standaard: 'Standaard',
  Hersteld: 'Hersteld',
  IngetrokkenGepubliceerd: 'IngetrokkenGepubliceerd',
} as const;

export interface ParagraafSchema {
  ID: string;
  Index: number;
  Lineage: string;
  Nummer: number;
  ObjectStatus: ParagraafSchemaObjectStatus;
  Ontwerp: number;
  Stop_Lineage: number;
  Titel: string;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
}

export interface ParagraafLineageSchemaOptional {
  Besluit_lineage?: string;
  ID?: string;
}

export interface ParagraafLineageSchema {
  Besluit_lineage: string;
  ID: string;
}

export type PHBSchemaOptionalType =
  (typeof PHBSchemaOptionalType)[keyof typeof PHBSchemaOptionalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PHBSchemaOptionalType = {
  Eigen: 'Eigen',
  Publicatie: 'Publicatie',
  MBIO: 'MBIO',
} as const;

export interface PHBSchemaOptional {
  Besluit?: string;
  Hoofdstuk?: string;
  ID?: string;
  Paragraaf?: string;
  /** @maxLength 1000 */
  Rang?: string;
  Type?: PHBSchemaOptionalType;
}

export type PHBSchemaType = (typeof PHBSchemaType)[keyof typeof PHBSchemaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PHBSchemaType = {
  Eigen: 'Eigen',
  Publicatie: 'Publicatie',
  MBIO: 'MBIO',
} as const;

export interface PHBSchema {
  Besluit: string;
  Hoofdstuk: string;
  ID: string;
  Paragraaf: string;
  /** @maxLength 1000 */
  Rang: string;
  Type: PHBSchemaType;
}

export interface OverwegingHoofdstukSchemaOptional {
  Besluit?: string;
  Hoofdstuk_lineage?: string;
  ID?: string;
  InhoudelijkeOverweging?: string;
}

export interface OverwegingHoofdstukSchema {
  Besluit: string;
  Hoofdstuk_lineage: string;
  ID: string;
  InhoudelijkeOverweging: string;
}

export interface OverwegingHoofdstukOpmerkingSchemaOptional {
  Check?: number;
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Index?: number;
  Modified_By?: string;
  Modified_Date?: string;
  Opmerking?: string;
  OverwegingHoofdstuk?: string;
}

export interface OverwegingHoofdstukOpmerkingSchema {
  Check: number;
  Created_By: string;
  Created_Date: string;
  ID: string;
  Index: number;
  Modified_By: string;
  Modified_Date: string;
  Opmerking: string;
  OverwegingHoofdstuk: string;
}

export type LabelSchemaOptionalStatus =
  (typeof LabelSchemaOptionalStatus)[keyof typeof LabelSchemaOptionalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabelSchemaOptionalStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface LabelSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Label?: string;
  Landelijk?: number;
  Map?: string;
  Modified_By?: string;
  Modified_Date?: string;
  Status?: LabelSchemaOptionalStatus;
}

export type LabelSchemaStatus =
  (typeof LabelSchemaStatus)[keyof typeof LabelSchemaStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabelSchemaStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface LabelSchema {
  Created_By: string;
  Created_Date: string;
  ID: string;
  Label: string;
  Landelijk: number;
  Map: string;
  Modified_By: string;
  Modified_Date: string;
  Status: LabelSchemaStatus;
}

export interface LabelMapSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Landelijk?: number;
  /** @nullable */
  Map?: string | null;
  Modified_By?: string;
  Modified_Date?: string;
  Naam?: string;
  Tenant?: string;
}

export interface LabelMapSchema {
  Created_By: string;
  Created_Date: string;
  ID: string;
  Landelijk: number;
  /** @nullable */
  Map?: string | null;
  Modified_By: string;
  Modified_Date: string;
  Naam: string;
  Tenant: string;
}

export type InstallatieTypeSchemaOptionalStatus =
  (typeof InstallatieTypeSchemaOptionalStatus)[keyof typeof InstallatieTypeSchemaOptionalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InstallatieTypeSchemaOptionalStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface InstallatieTypeSchemaOptional {
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Installatie_Type?: string;
  Landelijk?: number;
  Modified_By?: string;
  Modified_Date?: string;
  Status?: InstallatieTypeSchemaOptionalStatus;
  Tenant?: string;
}

export type InstallatieTypeSchemaStatus =
  (typeof InstallatieTypeSchemaStatus)[keyof typeof InstallatieTypeSchemaStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InstallatieTypeSchemaStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface InstallatieTypeSchema {
  Created_By: string;
  Created_Date: string;
  ID: string;
  Installatie_Type: string;
  Landelijk: number;
  Modified_By: string;
  Modified_Date: string;
  Status: InstallatieTypeSchemaStatus;
  Tenant: string;
}

export type HoofdstukSchemaOptionalObjectStatus =
  (typeof HoofdstukSchemaOptionalObjectStatus)[keyof typeof HoofdstukSchemaOptionalObjectStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HoofdstukSchemaOptionalObjectStatus = {
  Standaard: 'Standaard',
  Hersteld: 'Hersteld',
  IngetrokkenGepubliceerd: 'IngetrokkenGepubliceerd',
} as const;

export interface HoofdstukSchemaOptional {
  Grondslag?: string;
  ID?: string;
  Index?: number;
  Lineage?: string;
  Nummer?: number;
  ObjectStatus?: HoofdstukSchemaOptionalObjectStatus;
  Ontwerp?: number;
  Stop_Lineage?: number;
  Titel?: string;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
}

export type HoofdstukSchemaObjectStatus =
  (typeof HoofdstukSchemaObjectStatus)[keyof typeof HoofdstukSchemaObjectStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HoofdstukSchemaObjectStatus = {
  Standaard: 'Standaard',
  Hersteld: 'Hersteld',
  IngetrokkenGepubliceerd: 'IngetrokkenGepubliceerd',
} as const;

export interface HoofdstukSchema {
  Grondslag: string;
  ID: string;
  Index: number;
  Lineage: string;
  Nummer: number;
  ObjectStatus: HoofdstukSchemaObjectStatus;
  Ontwerp: number;
  Stop_Lineage: number;
  Titel: string;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
}

export interface HoofdstukReserveringSchemaOptional {
  Gebruiker?: string;
  Geldig_Tot?: string;
  ID?: string;
  Reservering_lineage?: string;
}

export interface HoofdstukReserveringSchema {
  Gebruiker: string;
  Geldig_Tot: string;
  ID: string;
  Reservering_lineage: string;
}

export interface HoofdstukLineageSchemaOptional {
  Besluit_lineage?: string;
  ID?: string;
}

export interface HoofdstukLineageSchema {
  Besluit_lineage: string;
  ID: string;
}

export interface HistorischBesluitSchemaOptional {
  Bedrijf_lineage?: string;
  /** @nullable */
  Besluit_Datum?: string | null;
  /** @maxLength 100 */
  Besluit_Nummer?: string;
  /** @nullable */
  Besluit_Omschrijving?: string | null;
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Modified_By?: string;
  Modified_Date?: string;
}

export interface HistorischBesluitSchema {
  Bedrijf_lineage: string;
  /** @nullable */
  Besluit_Datum?: string | null;
  /** @maxLength 100 */
  Besluit_Nummer: string;
  /** @nullable */
  Besluit_Omschrijving?: string | null;
  Created_By: string;
  Created_Date: string;
  ID: string;
  Modified_By: string;
  Modified_Date: string;
}

export type HBSchemaOptionalType =
  (typeof HBSchemaOptionalType)[keyof typeof HBSchemaOptionalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HBSchemaOptionalType = {
  Eigen: 'Eigen',
  Publicatie: 'Publicatie',
  MBIO: 'MBIO',
} as const;

export interface HBSchemaOptional {
  Besluit?: string;
  Hoofdstuk?: string;
  ID?: string;
  Type?: HBSchemaOptionalType;
}

export type HBSchemaType = (typeof HBSchemaType)[keyof typeof HBSchemaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HBSchemaType = {
  Eigen: 'Eigen',
  Publicatie: 'Publicatie',
  MBIO: 'MBIO',
} as const;

export interface HBSchema {
  Besluit: string;
  Hoofdstuk: string;
  ID: string;
  Type: HBSchemaType;
}

export interface GrondslagSchema {
  ID: string;
  Landelijk: number;
  /** @maxLength 50 */
  Naam: string;
}

export interface GebruikerSchema {
  /** @maxLength 50 */
  Email: string;
  /** @maxLength 50 */
  Gebruikersnaam: string;
  ID: string;
  /** @maxLength 50 */
  Rol: string;
  Tenant: string;
  Wachtwoord: string;
}

export type FilterSchemaOp =
  (typeof FilterSchemaOp)[keyof typeof FilterSchemaOp];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterSchemaOp = {
  is_null: 'is_null',
  is_not_null: 'is_not_null',
  eq: 'eq',
  ne: 'ne',
  gt: 'gt',
  lt: 'lt',
  ge: 'ge',
  le: 'le',
  like: 'like',
  ilike: 'ilike',
  not_ilike: 'not_ilike',
  in: 'in',
  not_in: 'not_in',
} as const;

export interface FilterSchema {
  field: string;
  model?: string;
  op: FilterSchemaOp;
  /** @maxLength 102400 */
  value: string;
}

export interface EmImIssieSchemaOptional {
  /** @nullable */
  Gegeven?: string | null;
  ID?: string;
  Voorschrift?: string;
}

export interface EmImIssieSchema {
  /** @nullable */
  Gegeven?: string | null;
  ID: string;
  Voorschrift: string;
}

export interface DefinitieSchemaOptional {
  /** @nullable */
  Definitie?: string | null;
  ID?: string;
  Voorschrift?: string;
}

export interface DefinitieSchema {
  /** @nullable */
  Definitie?: string | null;
  ID: string;
  Voorschrift: string;
}

export type BevoegdGezagSchemaOptionalObjectStatus =
  (typeof BevoegdGezagSchemaOptionalObjectStatus)[keyof typeof BevoegdGezagSchemaOptionalObjectStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BevoegdGezagSchemaOptionalObjectStatus = {
  Standaard: 'Standaard',
  Hersteld: 'Hersteld',
  IngetrokkenGepubliceerd: 'IngetrokkenGepubliceerd',
} as const;

export interface BevoegdGezagSchemaOptional {
  ID?: string;
  Index?: number;
  Landelijk?: number;
  Lineage?: string;
  /** @maxLength 100 */
  Naam?: string;
  ObjectStatus?: BevoegdGezagSchemaOptionalObjectStatus;
  Stop_Lineage?: number;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
}

export type BevoegdGezagSchemaObjectStatus =
  (typeof BevoegdGezagSchemaObjectStatus)[keyof typeof BevoegdGezagSchemaObjectStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BevoegdGezagSchemaObjectStatus = {
  Standaard: 'Standaard',
  Hersteld: 'Hersteld',
  IngetrokkenGepubliceerd: 'IngetrokkenGepubliceerd',
} as const;

export interface BevoegdGezagSchema {
  ID: string;
  Index: number;
  Landelijk: number;
  Lineage: string;
  /** @maxLength 100 */
  Naam: string;
  ObjectStatus: BevoegdGezagSchemaObjectStatus;
  Stop_Lineage: number;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
}

export interface BevoegdGezagLineageSchemaOptional {
  ID?: string;
  Tenant?: string;
}

export interface BevoegdGezagLineageSchema {
  ID: string;
  Tenant: string;
}

export interface BesluitTypeSchema {
  Actief: number;
  ID: string;
  Initieel: number;
  /** @maxLength 50 */
  Naam: string;
  Wijziging_zonder_besluit: number;
}

export type BesluitSchemaOptionalStatus =
  (typeof BesluitSchemaOptionalStatus)[keyof typeof BesluitSchemaOptionalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BesluitSchemaOptionalStatus = {
  Publicatie: 'Publicatie',
  Ontwerp: 'Ontwerp',
  Bevroren: 'Bevroren',
  Opmerking: 'Opmerking',
} as const;

export interface BesluitSchemaOptional {
  /** @nullable */
  Algemene_Overweging?: string | null;
  Bedrijf?: string;
  /** @nullable */
  Begin_Geldigheid?: string | null;
  /** @nullable */
  Begrippen?: string | null;
  /** @nullable */
  Besluit_Datum?: string | null;
  /** @nullable */
  Besluit_Tekst?: string | null;
  /** @nullable */
  Bijlage?: string | null;
  /** @nullable */
  Duiding?: string | null;
  /** @nullable */
  Eind_Geldigheid?: string | null;
  ID?: string;
  /** @nullable */
  Index?: number | null;
  Lineage?: string;
  /**
   * @maxLength 100
   * @nullable
   */
  OLO_Nummer?: string | null;
  /** @nullable */
  Omschrijving?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Ons_Kenmerk?: string | null;
  Ontwerp_Beschikking?: number;
  /** @nullable */
  Overige_Overweging?: string | null;
  Status?: BesluitSchemaOptionalStatus;
  /** @nullable */
  Toetsingskader?: string | null;
  Type?: string;
  /**
   * @maxLength 100
   * @nullable
   */
  Uw_Kenmerk?: string | null;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Zaaknummer?: string | null;
}

export type BesluitSchemaStatus =
  (typeof BesluitSchemaStatus)[keyof typeof BesluitSchemaStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BesluitSchemaStatus = {
  Publicatie: 'Publicatie',
  Ontwerp: 'Ontwerp',
  Bevroren: 'Bevroren',
  Opmerking: 'Opmerking',
} as const;

export interface BesluitSchema {
  /** @nullable */
  Algemene_Overweging?: string | null;
  Bedrijf: string;
  /** @nullable */
  Begin_Geldigheid?: string | null;
  /** @nullable */
  Begrippen?: string | null;
  /** @nullable */
  Besluit_Datum?: string | null;
  /** @nullable */
  Besluit_Tekst?: string | null;
  /** @nullable */
  Bijlage?: string | null;
  /** @nullable */
  Duiding?: string | null;
  /** @nullable */
  Eind_Geldigheid?: string | null;
  ID: string;
  /** @nullable */
  Index?: number | null;
  Lineage: string;
  /**
   * @maxLength 100
   * @nullable
   */
  OLO_Nummer?: string | null;
  /** @nullable */
  Omschrijving?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Ons_Kenmerk?: string | null;
  Ontwerp_Beschikking: number;
  /** @nullable */
  Overige_Overweging?: string | null;
  Status: BesluitSchemaStatus;
  /** @nullable */
  Toetsingskader?: string | null;
  Type: string;
  /**
   * @maxLength 100
   * @nullable
   */
  Uw_Kenmerk?: string | null;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Zaaknummer?: string | null;
}

export type BesluitOpmerkingSchemaOptionalVeld =
  (typeof BesluitOpmerkingSchemaOptionalVeld)[keyof typeof BesluitOpmerkingSchemaOptionalVeld];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BesluitOpmerkingSchemaOptionalVeld = {
  AlgemeneOverweging: 'AlgemeneOverweging',
} as const;

export interface BesluitOpmerkingSchemaOptional {
  Besluit?: string;
  Check?: number;
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Index?: number;
  Modified_By?: string;
  Modified_Date?: string;
  Opmerking?: string;
  Veld?: BesluitOpmerkingSchemaOptionalVeld;
}

export type BesluitOpmerkingSchemaVeld =
  (typeof BesluitOpmerkingSchemaVeld)[keyof typeof BesluitOpmerkingSchemaVeld];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BesluitOpmerkingSchemaVeld = {
  AlgemeneOverweging: 'AlgemeneOverweging',
} as const;

export interface BesluitOpmerkingSchema {
  Besluit: string;
  Check: number;
  Created_By: string;
  Created_Date: string;
  ID: string;
  Index: number;
  Modified_By: string;
  Modified_Date: string;
  Opmerking: string;
  Veld: BesluitOpmerkingSchemaVeld;
}

export interface BesluitLineageSchemaOptional {
  ID?: string;
  Tenant?: string;
}

export interface BesluitLineageSchema {
  ID: string;
  Tenant: string;
}

export interface BesluitGrondslagSchema {
  Besluit: string;
  Grondslag: string;
  ID: string;
}

export interface BedrijfSchemaOptional {
  BevoegdGezag?: string;
  /**
   * @maxLength 100
   * @nullable
   */
  Branche?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Emailadres?: string | null;
  Goedgekeurd?: number;
  /**
   * @maxLength 20
   * @nullable
   */
  Huisnummer?: string | null;
  ID?: string;
  /**
   * @maxLength 50
   * @nullable
   */
  KVKNummer?: string | null;
  Lineage?: string;
  /**
   * @maxLength 100
   * @nullable
   */
  Locatienummer?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Naam?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Plaatsnaam?: string | null;
  /**
   * @maxLength 6
   * @nullable
   */
  Postcode?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Straatnaam?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Telefoonnummer?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Tenant?: string | null;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
}

export interface BedrijfSchema {
  BevoegdGezag: string;
  /**
   * @maxLength 100
   * @nullable
   */
  Branche?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Emailadres?: string | null;
  Goedgekeurd: number;
  /**
   * @maxLength 20
   * @nullable
   */
  Huisnummer?: string | null;
  ID: string;
  /**
   * @maxLength 50
   * @nullable
   */
  KVKNummer?: string | null;
  Lineage: string;
  /**
   * @maxLength 100
   * @nullable
   */
  Locatienummer?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Naam?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Plaatsnaam?: string | null;
  /**
   * @maxLength 6
   * @nullable
   */
  Postcode?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Straatnaam?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Telefoonnummer?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  Tenant?: string | null;
  /** @nullable */
  Volgend?: string | null;
  /** @nullable */
  Vorig?: string | null;
}

export interface BedrijfLineageSchemaOptional {
  ID?: string;
  Tenant?: string;
}

export interface BedrijfLineageSchema {
  ID: string;
  Tenant: string;
}

export type BedrijfInstallatieSchemaOptionalStatus =
  (typeof BedrijfInstallatieSchemaOptionalStatus)[keyof typeof BedrijfInstallatieSchemaOptionalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BedrijfInstallatieSchemaOptionalStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface BedrijfInstallatieSchemaOptional {
  Bedrijf_lineage?: string;
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Installatie_type?: string;
  Modified_By?: string;
  Modified_Date?: string;
  /** @maxLength 100 */
  Naam?: string;
  Status?: BedrijfInstallatieSchemaOptionalStatus;
}

export type BedrijfInstallatieSchemaStatus =
  (typeof BedrijfInstallatieSchemaStatus)[keyof typeof BedrijfInstallatieSchemaStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BedrijfInstallatieSchemaStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface BedrijfInstallatieSchema {
  Bedrijf_lineage: string;
  Created_By: string;
  Created_Date: string;
  ID: string;
  Installatie_type: string;
  Modified_By: string;
  Modified_Date: string;
  /** @maxLength 100 */
  Naam: string;
  Status: BedrijfInstallatieSchemaStatus;
}

export type BedrijfActiviteitSchemaOptionalStatus =
  (typeof BedrijfActiviteitSchemaOptionalStatus)[keyof typeof BedrijfActiviteitSchemaOptionalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BedrijfActiviteitSchemaOptionalStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface BedrijfActiviteitSchemaOptional {
  Activiteit_categorie?: string;
  Bedrijf_lineage?: string;
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Modified_By?: string;
  Modified_Date?: string;
  Status?: BedrijfActiviteitSchemaOptionalStatus;
}

export type BedrijfActiviteitSchemaStatus =
  (typeof BedrijfActiviteitSchemaStatus)[keyof typeof BedrijfActiviteitSchemaStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BedrijfActiviteitSchemaStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface BedrijfActiviteitSchema {
  Activiteit_categorie: string;
  Bedrijf_lineage: string;
  Created_By: string;
  Created_Date: string;
  ID: string;
  Modified_By: string;
  Modified_Date: string;
  Status: BedrijfActiviteitSchemaStatus;
}

export type ActiviteitCategorieSchemaOptionalStatus =
  (typeof ActiviteitCategorieSchemaOptionalStatus)[keyof typeof ActiviteitCategorieSchemaOptionalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActiviteitCategorieSchemaOptionalStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface ActiviteitCategorieSchemaOptional {
  Activiteit_Categorie?: string;
  Created_By?: string;
  Created_Date?: string;
  ID?: string;
  Landelijk?: number;
  Modified_By?: string;
  Modified_Date?: string;
  Status?: ActiviteitCategorieSchemaOptionalStatus;
  Tenant?: string;
}

export type ActiviteitCategorieSchemaStatus =
  (typeof ActiviteitCategorieSchemaStatus)[keyof typeof ActiviteitCategorieSchemaStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActiviteitCategorieSchemaStatus = {
  Actief: 'Actief',
  Archief: 'Archief',
} as const;

export interface ActiviteitCategorieSchema {
  Activiteit_Categorie: string;
  Created_By: string;
  Created_Date: string;
  ID: string;
  Landelijk: number;
  Modified_By: string;
  Modified_Date: string;
  Status: ActiviteitCategorieSchemaStatus;
  Tenant: string;
}
